export default "/images/43cb8b32ad66d0e88d324ce7fa251e97.png";